import React, { useState, useEffect } from "react";
// @ts-ignore
import { Helmet, HelmetProvider } from "react-helmet-async";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../styles/theme";

import { AdBannerData } from "../types";
import { withVersionParams } from "../HOC/withVersionParams";
import AdBanner from "../components/AdBannerPage/AdBanner";
import { adBannerData } from "../constants/AdBannerData";

const useStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
   },
}));

interface Props {
   adBannerData: AdBannerData[];
}

const BannerPage: React.FC = () => {
   const classes = useStyles();
   const [currentIdx, setCurrentIdx] = useState<number>(0);

   const adBannerDataArr = Object.values(adBannerData).sort(
      (a: AdBannerData, b: AdBannerData) => a.order - b.order
   );

   useEffect(() => {
      const timer = setInterval(() => {
         setCurrentIdx(
            currentIdx === adBannerDataArr.length - 1 ? 0 : currentIdx + 1
         );
      }, 3000);
      return () => {
         window.clearInterval(timer);
      };
   }, [currentIdx]);

   return (
      <>
         <HelmetProvider>
            <Helmet>
               <title>Banner</title>
            </Helmet>
         </HelmetProvider>
         <div
            className={classes.wrap}
            style={{
               backgroundColor: adBannerDataArr[currentIdx].bgColor,
            }}
         >
            <AdBanner data={adBannerDataArr[currentIdx]} />
         </div>
      </>
   );
};

export default withVersionParams(BannerPage);
